<body>


    <div class="img-log">
        <img src="..././../assets/images/log-marketingApp.png">
    </div>
    <div class="clean-login">
        
      <form>
       <div class="f-width">
        <h1 class="heading">
            Welcome..
        </h1><h2>Back..!</h2>
        <p>Please enter the <span>login</span> details</p>
      </div> 
      
      <form>
        <form  [formGroup]="loginForm">
            
        <div class="form1">
            <div class="form-group">
              <label>User name</label>
              <input type="text" class="form-control" formControlName="userName"  placeholder="Type here">
            </div>
            
            <div class="form-group icon-log">
                <label>Password</label>
                <input type="password" class="form-control" formControlName="password" placeholder="Type here">
                <a href=""><img src=".././../assets/images/eye-open.png"></a>
              </div>
         </div>  
        <div class="btn-div">
            <button type="submit" class="btn btn-primary" (click)="onSubmit()">Submit</button>
        </div>
          </form>
      </form>
    
      <!-- <div class="poster">
        <div class="log">
            <img src=".././../assets/images/log-login.png">
        </div>
      </div> -->
     </form>
    </div>
    
    <footer class="footer-main">
      <img src=".././../assets/images/accruon-footer.png">
      <!-- Powered by <span>Accruon Technologies Pvt Ltd</span> -->
    </footer>
    </body>
    